'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var propose = require('./propose');

var exchange = require('./exchange');

var finish = require('./finish'); // Performs initial communication over insecure channel to share keys, IDs,
// and initiate communication, assigning all necessary params.


module.exports = /*#__PURE__*/function () {
  var _handshake = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, wrapped) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return propose(state, wrapped);

          case 2:
            _context.next = 4;
            return exchange(state, wrapped);

          case 4:
            _context.next = 6;
            return finish(state, wrapped);

          case 6:
            state.cleanSecrets();

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function handshake(_x, _x2) {
    return _handshake.apply(this, arguments);
  }

  return handshake;
}();